var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-action-bar" },
    [
      _vm.canUpdateRelated
        ? _c(
            "CompassTooltip",
            { attrs: { arrow: false, content: _vm.labels.addRelatedObject } },
            [
              _c("CompassIconButton", {
                attrs: { icon: "objects-linked", size: "small" },
                on: {
                  click: function($event) {
                    _vm.showLinkObjectDialog = true
                  }
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "CompassTooltip",
        { attrs: { arrow: false, content: _vm.labels.showHistoryTooltip } },
        [
          _c("CompassIconButton", {
            attrs: {
              icon: "history",
              size: "small",
              active: _vm.displayHistory
            },
            on: {
              click: function($event) {
                return _vm.$emit("toggleHistory")
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.showPinIcon
        ? _c(
            "CompassTooltip",
            { attrs: { arrow: false, content: _vm.pinStatusLabel } },
            [
              _c("CompassIconButton", {
                attrs: { icon: "pin", size: "small", active: _vm.isPinned },
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    return _vm.onClickPin($event)
                  }
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.isFailedToSend
        ? _c(
            "CompassTooltip",
            { attrs: { arrow: false, content: _vm.labels.showEmailTooltip } },
            [
              _c("CompassIconButton", {
                attrs: { icon: "panel-right-expand", size: "small" },
                on: {
                  click: function($event) {
                    return _vm.previewElement(_vm.oneLog)
                  }
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.shouldDisplayMenuMoreActions
        ? _c(
            "div",
            [
              _c(
                "div",
                { ref: "customTooltip", class: _vm.customTooltipClasses },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.labels.moreActionsTooltip) +
                      "\n        "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "CompassMenu",
                {
                  ref: "actionBarMenu",
                  attrs: {
                    size: "small",
                    placement: "top-end",
                    disabled: !_vm.isActionBarVisible
                  }
                },
                [
                  _c("CompassIconButton", {
                    attrs: { icon: "action", size: "small" },
                    on: {
                      click: _vm.handleCustomTooltipVisibility,
                      mouseenter: _vm.handleCustomTooltipVisibility,
                      mouseleave: _vm.handleCustomTooltipVisibility
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "template",
                    { slot: "dropdown" },
                    [
                      _vm.canLinkEmail
                        ? _c("CompassMenuItem", {
                            attrs: { label: _vm.labels.menuLinkEmail },
                            on: {
                              click: function($event) {
                                return _vm.linkElement(_vm.oneLog)
                              }
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.oneLog.email.scheduled
                        ? _c("CompassMenuItem", {
                            attrs: { label: _vm.labels.menuCancelSendEmail },
                            on: {
                              click: function($event) {
                                return _vm.cancelSendElement(_vm.oneLog)
                              }
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                2
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.canUpdateRelated
        ? _c("LinkObjectDialog", {
            attrs: {
              isVisible: _vm.showLinkObjectDialog,
              related: _vm.linkedsFormated,
              isLoading: _vm.linkObjectDialogLoading,
              hasError: _vm.hasRelatedUpdateError,
              emptyStateData: _vm.emptyStateData
            },
            on: {
              close: function($event) {
                _vm.showLinkObjectDialog = false
              },
              "update:related": _vm.updateRelatedObjects
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }